import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';

export interface NominalForceItemProps {
    product: ProductInterface
    isLast: boolean
}

export class NominalForceItem extends React.PureComponent<NominalForceItemProps> {
    public render() {
        const props = this.props;

        return <><span>{props.product.name}</span>{props.isLast ? '' : ', '}</>;
    }
}
